import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import DynamicTable from "../../../../Components/Common/DynamicTable";
import { restructureData } from "../../../../utils/restructureData";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

const GRI404_1 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [data, setData] = useState({});
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);
  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const inputData = [
    {
      fieldName: "perfomanceAndCareerDevlopment",
      title:
        "a. What percentage of the total workforce, categorized by gender and employee category, participated in regular performance and career development reviews during the reporting period?",
      fields: [
        {
          fieldName: "category",
          title: "Employee Category",
          type: "text",
          //   options: [
          //     "Full-Time",
          //     "Part-Time",
          //     "Contract",
          //     "Intern",
          //     "Freelancer",
          //     "Temporary",
          //     "Remote",
          //     "On-Site",
          //   ],
          placeholder: "Type Here",
        },
        {
          fieldName: "malePercentage",
          title:
            "Percentage of male employees participated in regular performance and career development",
          type: "percentage",
          placeholder: "Type Here",
        },
        {
          fieldName: "femalePercentage",
          title:
            "Percentage of female employees participated in regular performance and career development",
          type: "percentage",
          placeholder: "Type Here",
        },
      ],
    },
  ];

  const [tables, setTables] = React.useState(
    // inputData.map((section) => ({ fieldName: section.fieldName, rows: [{}] }))
    []
  );

  const [tabErrors, setTabErrors] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI400&Id=${id}`);
        if (response?.data?.data?.year < currentYear - 1)
          setDisabled(true);
        const data1 = response.data.data.GRI400 || {};
        setData(data1);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleSubmit = async () => {
    if (!disabled) {
      // const isTableValid = validateTable(inputData, tables, setTabErrors);

      // if (!isTableValid ) {
      //   return;
      // }

      let transformedData = restructureData(tables);

      const payload = {
        type: "GRI400",
        submitted404_3: true,
        ...transformedData,
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/gri400/405-1/${id}`);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/405-1/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {!hide && (
        <p className={styles.section_heading}>404 : Training and Education</p>
      )}
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-2rem" : "0" }}
      >
        404-3 : Percentage of employees receiving regular performance and career
        development reviews
      </p>
      <Box sx={{ marginTop: "1rem" }}>
        {/* <SectionHeading text="a. What percentage of the total workforce, categorized by gender and employee category, participated in regular performance and career development reviews during the reporting period?"  /> */}

        <Box>
          <DynamicTable
            inputData={inputData}
            tables={tables}
            data={data}
            setTables={setTables}
            errors={tabErrors}
            setErrors={setTabErrors}
            disabled={disabled}
            hide={hide}
          />
        </Box>

        {/* Submit Button */}

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI404_1;
